const SHUTTLEOPS_URL = 'https://www.shuttleops.com/';

export const buildComparisonStructuredData = ({
  canonicalHref,
  competitor,
  competitorUrl,
  description,
  lastChecked,
  name,
}) => ({
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${canonicalHref}#webpage`,
  url: canonicalHref,
  name,
  description,
  dateModified: lastChecked,
  inLanguage: 'en-GB',
  about: [
    {
      '@type': 'SoftwareApplication',
      name: 'ShuttleOps',
      url: SHUTTLEOPS_URL,
    },
    {
      '@type': 'SoftwareApplication',
      name: competitor,
      url: competitorUrl,
    },
  ],
});
